import moment from 'moment'

import { EIcons } from '@/app/types/iconType'
import { type IBugReport } from '@/app/types/settingsTypes'
import { common } from '@/app/utils'
import { Button, Icon } from '@/shared'

import style from './RepostItem.module.scss'

interface IProps extends IBugReport {
    onRemoveBugReport: (id: string) => void
    onSetSearchableAgentId: (searchableAgentId: string | null) => void
}

export const RepostItem = (props: IProps) => {
    const { id, message, author, createdAt, email, phone, agentId, onRemoveBugReport, onSetSearchableAgentId } = props
    return (
        <div className={style.container}>
            <div className={style.wrapper}>
                <div className={style.userWrapper}>
                    <div className={style.author}>
                        <span>{author}</span>
                    </div>
                    <div className={style.date}>
                        <span>{moment(createdAt).locale('ru').format('LL')}</span>
                    </div>
                </div>
                <div className={style.contactsWrapper}>
                    {email && (
                        <div className={style.email}>
                            <span>{email}</span>
                        </div>
                    )}
                    {phone && (
                        <div className={style.phone}>
                            <span>{common.onGetPhoneFrontFormat(phone)}</span>
                        </div>
                    )}
                </div>
                <div className={style.serchSlots}>
                    <Button onClick={() => onSetSearchableAgentId(agentId)}>Смотреть слоты</Button>
                </div>
                <div className={style.message}>
                    <span>{message}</span>
                </div>
            </div>
            <div className={style.editIcon} onClick={() => onRemoveBugReport(id)}>
                <Icon iconName={EIcons.TRSH} />
            </div>
        </div>
    )
}
